/**
 * ConditionalLayout
 *
 * Route-aware shell switcher:
 * - App routes (including /client/*) → AppSectionLayout (sidebar + header + content + footer)
 * - Auth / marketing routes → children only (no app chrome)
 */

'use client'

import React, { useMemo } from 'react'
import { usePathname } from 'next/navigation'
import { AppSectionLayout } from './AppShellLayout'
import { isChromeFreeRoute } from './isChromeFreeRoute'

export { isChromeFreeRoute }

interface ConditionalLayoutProps {
  children: React.ReactNode
}

export const ConditionalLayout: React.FC<ConditionalLayoutProps> = ({ children }) => {
  const pathname = usePathname()

  const useAppShell = useMemo(
    () => !isChromeFreeRoute(pathname),
    [pathname]
  )

  if (useAppShell) {
    return <AppSectionLayout>{children}</AppSectionLayout>
  }

  // Landing, auth, pricing, help, legal — no shell thrash
  return <>{children}</>
}
